/**
 * 精彩候选列表提示 & 边界反馈按钮文案（按直播类型）。
 * feedbackType 仍为 HALF_SONG / HAS_CHAT / GOOD，仅展示文案不同。
 */

const COPY = {
  SING: {
    listHint:
      '唱歌优先展示约 2 分钟以上的整首候选，并尽量覆盖全片多首歌。边界不准可用「微调」重切，或点「半首 / 含聊天 / 可用」反馈。',
    feedbackHalf: '半首',
    feedbackNoise: '含聊天',
    feedbackGood: '可用',
    tuneExtra: '若切到半首或含聊天，可用下方「半首 / 含聊天」反馈，方便后续改进。',
  },
  DANCE: {
    listHint:
      '舞蹈优先展示约 2 分钟以上的成段候选（策略暂同唱歌），并尽量覆盖全片多段。边界不准可用「微调」重切，或点「半段 / 含聊天 / 可用」反馈。',
    feedbackHalf: '半段',
    feedbackNoise: '含聊天',
    feedbackGood: '可用',
    tuneExtra: '若切到半段或含聊天，可用下方「半段 / 含聊天」反馈，方便后续改进。',
  },
  SHOW: {
    listHint:
      '「其他」优先展示聊天/互动高光（约 15～90 秒）。边界不准可用「微调」重切，或点「切偏了 / 含冷场 / 可用」反馈。',
    feedbackHalf: '切偏了',
    feedbackNoise: '含冷场',
    feedbackGood: '可用',
    tuneExtra: '若切偏或含冷场，可用下方「切偏了 / 含冷场」反馈，方便后续改进。',
  },
  GAME: {
    listHint:
      '游戏优先展示高燃片段（大叫/紧凑喊麦等）。不够精彩时宁缺毋滥，可能少于所选条数。边界不准可用「微调」重切，或点「切偏了 / 含水 / 可用」反馈。',
    feedbackHalf: '切偏了',
    feedbackNoise: '含水',
    feedbackGood: '可用',
    tuneExtra: '若切偏或含水，可用下方「切偏了 / 含水」反馈，方便后续改进。',
  },
};

const FALLBACK = COPY.GAME;

export function highlightFeedbackCopy(liveCategory) {
  const key = String(liveCategory || 'GAME').toUpperCase();
  return COPY[key] || FALLBACK;
}

export function feedbackTypeLabel(liveCategory, feedbackType) {
  const copy = highlightFeedbackCopy(liveCategory);
  if (feedbackType === 'HALF_SONG') return copy.feedbackHalf;
  if (feedbackType === 'HAS_CHAT') return copy.feedbackNoise;
  if (feedbackType === 'GOOD') return copy.feedbackGood;
  return feedbackType || '';
}
